import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { DA_DETAIL_SELECT } from '../lib/utils';
import { readWithTimeout } from '../lib/supabaseRead';
import { displayDAIdentifier, displayDALocation } from '../lib/daDisplay';

export default function NotificationProjects({ target, onOpenDA, onClose, theme, hidden = false }) {
  const [state, setState] = useState({ loading: true, rows: [], error: false });
  const [retry, setRetry] = useState(0);
  const idsKey = target.ids.join(',');
  useEffect(() => {
    let cancelled = false;
    const ids = idsKey.split(',');
    setState({ loading: true, rows: [], error: false });
    readWithTimeout(signal => supabase.from('da_browse_view').select(DA_DETAIL_SELECT)
      .in('id', ids).abortSignal(signal), { label: 'notification_projects' })
      .then(({ data, error }) => {
        if (cancelled) return;
        const byId = new Map((data || []).map(row => [row.id, row]));
        setState({ loading: false, error: Boolean(error), rows: error ? [] : ids.map(id => byId.get(id)).filter(Boolean) });
      });
    return () => { cancelled = true; };
  }, [idsKey, retry]);
  return <section aria-label="Notification applications" hidden={hidden} style={{ display: hidden ? 'none' : undefined, position: 'fixed', inset: 0, zIndex: 1000, overflowY: 'auto', background: theme.bg, color: theme.text, padding: 20 }}>
    <button onClick={onClose} style={{ minHeight: 44 }}>Back to SiteScope</button>
    <h1 style={{ fontSize: 22 }}>{target.kind === 'exhibition' ? 'Exhibitions from your notification' : 'Applications from your notification'}</h1>
    <p>The latest available details are shown. Status and exhibition dates may have changed since this alert.</p>
    {target.total > target.ids.length && <p role="status">This notification covers {target.total} applications. The first {target.ids.length} are linked here.</p>}
    {state.loading ? <p role="status">Loading applications…</p> : state.error ? <div role="alert"><p>These applications could not be loaded. Your alert has been kept here so you can retry.</p><button onClick={() => setRetry(value => value + 1)}>Retry</button></div> : <>
      {state.rows.length < target.ids.length && <p role="status">{target.ids.length - state.rows.length} linked application(s) are no longer available to this account.</p>}
      {state.rows.map(da => <button key={da.id} onClick={() => onOpenDA(da)} style={{ display: 'block', width: '100%', textAlign: 'left', padding: 16, marginBottom: 10, borderRadius: 8, border: `1px solid ${theme.border}`, background: theme.card || theme.bg, color: theme.text }}>
        <strong>{displayDALocation(da, displayDAIdentifier(da))}</strong><br />
        <span>{displayDAIdentifier(da)} · {da.status || 'Status unknown'}</span>
      </button>)}
    </>}
  </section>;
}
